import OpeningText from "../Components/OpeningText.jsx";
import bannerLeft from '../videos/banner-left.m4v';
import './styles/Home.scss';

function Home() {


    return (
    <main>
      <section className="opening">
        <div className="container">
          <div className="openingInner">
            <OpeningText />
          </div>
        </div>
        <div className="openingAnimation">
          <video autoPlay muted loop playsInline>
            <source src={bannerLeft} type="video/mp4" />
          </video>
        </div>
      </section>
    </main>
    )
}

export default Home;